import { render, staticRenderFns } from "./FileCol.vue?vue&type=template&id=6292aab7&scoped=true&"
import script from "./FileCol.vue?vue&type=script&lang=js&"
export * from "./FileCol.vue?vue&type=script&lang=js&"
import style0 from "./FileCol.vue?vue&type=style&index=0&id=6292aab7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6292aab7",
  null
  
)

export default component.exports